var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFilter = function SvgFilter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26 22H14.86A4 4 0 0 0 11 19a4 4 0 0 0-3.86 3H2a1 1 0 1 0 0 2h5.14A4 4 0 0 0 11 27a4 4 0 0 0 3.86-3H26a1 1 0 1 0 0-2m-15 3a2 2 0 1 1 0-4 2 2 0 0 1 0 4m15-12h-2.14A4 4 0 0 0 20 10a4 4 0 0 0-3.86 3H2a1 1 0 1 0 0 2h14.14A4 4 0 0 0 20 18a4 4 0 0 0 3.86-3H26a1 1 0 1 0 0-2m-6 3a2 2 0 1 1 0-4 2 2 0 0 1 0 4m6-12H12.86A4 4 0 0 0 9 1a4 4 0 0 0-3.86 3H2a1 1 0 1 0 0 2h3.14A4 4 0 0 0 9 9a4 4 0 0 0 3.86-3H26a1 1 0 1 0 0-2M9 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
  })));
};
export default SvgFilter;